import { exportToExcel } from "../../utils/exportExcel";
import xlsIcon from "../../assets/icons/xlsIcon.svg";

const ExportButton = ({ excelConfig }) => {
  const {
    data = [],
    fileName = "Report",
    sheetName = "Sheet1",
    columnWidths,
  } = excelConfig;

  const handleExport = () => {
    exportToExcel({
      data: data,
      fileName: fileName,
      sheetName: sheetName,
      columnWidths,
    });
  };

  return (
    <button
      onClick={handleExport}
      className="ml-1 text-[10px] md:text-xs flex gap-1 items-center justify-between border-1 py-1 bg-[#00800014] transition-all hover:bg-emerald-50 text-emerald-700 border-emerald-600 rounded-md px-2 font-figtreeMedium"
    >
      <img src={xlsIcon} alt="xls" className="w-3 md:w-4 h-3 md:h-4" />
      Download
    </button>
  );
};

export default ExportButton;
